module.exports = __webpack_public_path__ + "img/gaji.2beda679.png";